import { Auth, connectAuthEmulator, getAuth } from '@angular/fire/auth';
import { environment } from '../../environments/environment';


export function authFactory(): () => Auth {
  return () => {
    const auth = getAuth(); // Initialisiert Auth basierend auf dem Angular-Fire-Kontext
    if ('useEmulators' in environment && environment.useEmulators) {
      connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
    }
    return auth;
  };
}
